import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import FleetReconciliationListScreen from './screens/FleetReconciliationListScreen';
import FleetReconciliationDetailScreen from './screens/FleetReconciliationDetailScreen';
import DriverReconciliationListScreen from './screens/DriverReconciliationListScreen';
import DriverReconciliationDetailScreen from './screens/DriverReconciliationDetailScreen';

FleetReconciliationReport.propTypes = {};

function FleetReconciliationReport(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0">
                <Routes>
                    <Route
                        path=""
                        element={
                            <FleetReconciliationListScreen />
                        }
                    />
                    <Route
                        path="/:agencyId/drivers"
                        element={
                            <DriverReconciliationListScreen />
                        }
                    />
                    <Route
                        path="/:agencyId/drivers/:reconciliationId"
                        element={
                            <DriverReconciliationDetailScreen />
                        }
                    />
                    <Route
                        path="/:reconciliationId"
                        element={
                            <FleetReconciliationDetailScreen />
                        }
                    />
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default FleetReconciliationReport;
